<div class="user-avatar-container">
  <i class="icon-user" [class.light-background]="lightBackground">
    <img *ngIf="profilePicture" [src]="profilePicture" lhLoadStatus />
  </i>
  <div *ngIf="notificationCount > 0" class="notification-badge">
    <div class="notification-count">{{ notificationCount }}</div>
  </div>
</div>
